import React, { useMemo } from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import RefundMethod from './RefundMethod';
import * as RefundMethodToggle from '../../RefundMethodToggle';
import { useRefundMethodsList } from '../context';

export default function List() {
  const { refundMethods, onRefundMethodUpdated } = useRefundMethodsList();

  const reasonsList = useMemo(() => {
    return refundMethods.map(data => {
      const slug = _get(data, 'payment_method', '');
      return (
        <RefundMethodToggle.Provider
          key={slug}
          method={data}
          onSaved={onRefundMethodUpdated}
        >
          <RefundMethod data={data} />
        </RefundMethodToggle.Provider>
      );
    });
  }, [refundMethods, onRefundMethodUpdated]);

  return (
    <UiKit.Flex direction="column" gap={8}>
      {reasonsList}
    </UiKit.Flex>
  );
}
